import { auditReports } from '@mi-front/api-clients';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { ButtonGroup } from '@mui/material';
import { useIntl } from 'react-intl';
import { AdaptiveButton } from '../../../../../../../../../components/base/AdaptiveButton';
import { ButtonLink } from '../../../../../../../../../components/base/ButtonLink';

interface Props {
  run: auditReports.AodRun;
  buttonsVariant?: 'short' | 'long';
}

/**
 * Button that navigates to the saved report detail page.
 * Renders an adaptive button (icon-only when short, with label when long).
 * In long variant, includes an "open in new tab" button alongside the main link.
 */
export function GoToReportBtn({ run, buttonsVariant = 'short' }: Props) {
  const { $t } = useIntl();

  if (!run.reportId) {
    return null;
  }

  const to = `/audit/saved-reports/${run.reportId}`;
  const goToReportText = $t({
    id: 'audit.aod.actions.goToReport',
    defaultMessage: 'Ir al reporte',
  });

  if (buttonsVariant === 'long') {
    return (
      <ButtonGroup size="small" color="primary" variant="outlined">
        <ButtonLink
          to={to}
          size="small"
          color="primary"
          variant="outlined"
          startIcon={<SummarizeIcon />}
        >
          {goToReportText}
        </ButtonLink>
        <ButtonLink to={to} openInNewTab size="small" color="primary" variant="outlined">
          &nbsp;
          <OpenInNewIcon fontSize="small" />
          &nbsp;
        </ButtonLink>
      </ButtonGroup>
    );
  }

  return (
    <AdaptiveButton
      text={goToReportText}
      icon={<SummarizeIcon />}
      display="short"
      to={to}
      size="small"
      color="primary"
    />
  );
}
